import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import {
  FormattedMessage,
  WrappedComponentProps,
  injectIntl,
} from "react-intl";

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    alignItems: "left",
    flexDirection: "column",
    textAlign: "left",
  },
  paragraph: {
    marginBottom: 10,
  },
  subTitle: {
    fontSize: "0.85rem",
    fontWeight: 500,
  },
  text: {
    fontSize: ".75rem",
    lineHeight: 1.5,
    whiteSpace: "normal",
    overflowWrap: "break-word",
    color: "#4e5d78",
  },
}));

interface StepSevenTitleProps {}

const GetIdTitle: FC<StepSevenTitleProps & WrappedComponentProps> = (props) => {
  const classes = useStyles();

  return (
    <Box className={classes.content}>
      <Box className={classes.paragraph}>
        <Typography className={classes.subTitle}>
          <FormattedMessage id="get.id.header1" />
        </Typography>
        <Typography className={classes.text}>
          <FormattedMessage id="get.id.text1" />
        </Typography>
      </Box>
      <Box className={classes.paragraph}>
        <Typography className={classes.subTitle}>
          <FormattedMessage id="get.id.header2" />
        </Typography>
        <Typography className={classes.text}>
          <FormattedMessage id="get.id.text2" />
        </Typography>
      </Box>
      <Box className={classes.paragraph}>
        <Typography className={classes.subTitle}>
          <FormattedMessage id="get.id.header3" />
        </Typography>
        <Typography className={classes.text}>
          <FormattedMessage id="get.id.text3.1" />
        </Typography>
        <Typography className={classes.text}>
          <FormattedMessage id="get.id.text3.2" />
        </Typography>
      </Box>
      <Box className={classes.paragraph}>
        <Typography className={classes.text}>
          <strong>
            <FormattedMessage id="get.id.text4" />
          </strong>
        </Typography>
      </Box>
    </Box>
  );
};

export default injectIntl(GetIdTitle);
